/** Centralized data-testid constants. */
export const TID = {
  // Layout
  sidebar: "app-sidebar",
  navDashboard: "nav-dashboard",
  navNewSequence: "nav-new-sequence",
  navLibrary: "nav-library",
  navSettings: "nav-settings",

  // Dashboard
  dashboardRoot: "dashboard-root",
  statsTotal: "stat-total",
  statsTracked: "stat-tracked",
  statsLabeled: "stat-labeled",
  statsDuration: "stat-duration",
  newSequenceBtn: "new-sequence-button",
  libraryTable: "library-table",
  libraryRow: (id) => `library-row-${id}`,
  rowDeleteBtn: (id) => `delete-sequence-${id}`,
  rowOpenBtn: (id) => `open-sequence-${id}`,

  // Wizard
  wizardRoot: "wizard-root",
  wizardStep: (n) => `wizard-step-${n}`,
  wizardNextBtn: "wizard-next-button",
  wizardBackBtn: "wizard-back-button",

  // Step 1
  uploadDropzone: "upload-dropzone",
  uploadInput: "upload-input",
  uploadFilename: "upload-filename",
  cfgFormat: "cfg-format",
  cfgGender: "cfg-gender",
  cfgSplit: "config-split",
  createSequenceBtn: "create-sequence-button",

  // Step 2
  calibrationCanvas: "calibration-canvas",
  calibrationImage: "calibration-image",
  resetCalibrationBtn: "reset-calibration-button",
  saveCalibrationBtn: "save-calibration-button",

  // Step 3
  cutterPlayer: "cutter-player",
  cutterSlider: "cutter-slider",
  startTrackingBtn: "start-tracking-button",
  trackingProgress: "tracking-progress",
  trackingMessage: "tracking-message",

  // Step 4
  labelOffense: "label-offense",
  labelDefense: "label-defense",
  labelPhase: "label-phase",
  labelQuality: "label-quality",
  labelDifficulty: "label-difficulty",
  labelTagsInput: "label-tags-input",
  labelNote: "label-note",
  saveLabelsBtn: "save-labels-button",

  // Step 5
  previewCanvas: "preview-canvas",
  previewVideo: "preview-video",
  exportMp4Btn: "export-mp4-button",
  exportCsvBtn: "export-csv-button",
  exportJsonBtn: "export-json-button",
  finishBtn: "wizard-finish-button",
};
